const initialState = {};
const config = (state = {}, action) => {
    switch (action.type) {
        case 'ADD_CONFIG':
            return action.value;
        case 'USER_LOGOUT':
            return initialState;
        default:
            return localStorage.getItem("config") ? JSON.parse(localStorage.getItem('config')) : state;
    }
}
export default config


// WEBPACK FOOTER //
// ./src/app/utils/reducers/config.js